import { ModuleLayout } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { SkatConnectionContextProvider } from '@features/vatDeclarations/contexts/skatConnectionContext'

import { ControlBookkeepingIntegrationsList } from './elements/ControlBookkepingIntegrationsList'
import { IntegrationsFooter } from './elements/IntegrationsFooter'
import { IntegrationsSideActions } from './elements/IntegrationsSideActions'
import { InvoicesIntegrationsList } from './elements/InvoicesIntegrationsList'
import { MoreIntegrationsList } from './elements/MoreIntegrationsList'
import * as Styled from './styles'

export const Integrations = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <SkatConnectionContextProvider>
      <ModuleLayout title={t('navigation.menu.footer.label.add_ons')} sideActions={<IntegrationsSideActions />}>
        <Styled.IntegrationsContainer>
          <InvoicesIntegrationsList />
          <ControlBookkeepingIntegrationsList />
          <MoreIntegrationsList />
          <IntegrationsFooter />
        </Styled.IntegrationsContainer>
      </ModuleLayout>
    </SkatConnectionContextProvider>
  )
}
